import { render, staticRenderFns } from "./StyledDialogReviewOrder.vue?vue&type=template&id=1b858fbf&"
import script from "./StyledDialogReviewOrder.vue?vue&type=script&lang=js&"
export * from "./StyledDialogReviewOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports